import { Box, Typography } from "@mui/material";
import { Booking } from "services/manualBooking";

export const passengerNames = (booking: Booking) =>
  booking.passengers
    ?.map(
      (p) => p.fullName || `${p.firstName || ""} ${p.lastName || ""}`.trim(),
    )
    .filter(Boolean)
    .join(", ") || "N/A";

export const routeLabel = (booking: Booking) =>
  `${booking.from || "N/A"} → ${booking.to || "N/A"}`;

const BookingSummaryCard = ({ booking }: { booking: Booking }) => (
  <Box
    bgcolor="#F9FAFB"
    border="1px solid #E4E7EC"
    borderRadius="8px"
    p="16px"
    mb="24px"
  >
    <Typography fontSize={15} fontWeight={500} color="#101828" mb="4px">
      {routeLabel(booking)}
    </Typography>
    <Typography fontSize={13} color="#667085">
      PNR:{" "}
      <Box component="span" color="#101828">
        {booking.pnr || "N/A"}
      </Box>
    </Typography>
    <Typography fontSize={13} color="#667085">
      Passenger:{" "}
      <Box component="span" color="#101828" sx={{ textTransform: "uppercase" }}>
        {passengerNames(booking)}
      </Box>
    </Typography>
  </Box>
);

export default BookingSummaryCard;
